import { Box, List, ListItem, ListItemText, Typography, useMediaQuery, useTheme } from "@mui/material";

export const AvisoDePrivacidadFinbra = () => {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));

  const font_title = isMobileOrTablet ? 20 : 28;
  const font_text = isMobileOrTablet ? 14 : 18;
  return (
    <>
      <Box mx={isMobileOrTablet ? 4 : 25} my={6}>
        <Typography color={theme?.palette?.primary?.main} textAlign={"center"} fontWeight={700} fontSize={font_title}>
          Aviso de Privacidad
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={2}
        >
          Litore Avances, S.A.P.I. de C.V., SOFOM, E.N.R., en lo subsecuente “Finbra.com”, en su carácter de responsable
          de los datos personales, con domicilio en Avenida Paseo de la Reforma 2654, oficina 1404-A, Lomas Altas,
          Miguel Hidalgo, C.P. 11950, Ciudad de México, México, es responsable de recabar sus datos personales, del uso
          que se le dé a los mismos y de su protección.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Su información personal será utilizada para contar con un registro de sus datos como cliente, así como para
          conocerle y poder realizar una evaluación económica de su actividad y estar en posibilidades de otorgarle el
          servicio y producto que nos está solicitando. Para las finalidades antes mencionadas, requerimos obtener los
          siguientes datos personales:
        </Typography>

        <List
          component="ol"
          sx={{
            listStyleType: "decimal",
            pl: 4,
            "& li::marker": {
              color: theme.palette.primary.dark,
              fontWeight: "bold",
              fontSize: font_text,
            },
          }}
        >
          {[
            "Nombre o razón social",
            "Domicilio",
            "Número telefónico",
            "Estado civil (PFAE)",
            "Sexo (PFAE)",
            "Validación de datos biográficos y biométricos ante instituciones públicas, tales como el Instituto Nacional Electoral. (PFAE)",
            "Identificación Oficial",
            "Firma",
            "RFC",
            "CURP",
            "Fecha de Nacimiento o fecha de constitución",
            "Edad",
            "País de Origen",
            "Profesión, ocupación o giro comercial",
            "Actividad Económica",
            "Ingresos",
          ].map((text, index) => (
            <ListItem key={index} sx={{ display: "list-item", py: 0 }}>
              <ListItemText
                primaryTypographyProps={{ color: theme.palette.primary.dark, fontWeight: 400 }}
                primary={text}
              />
            </ListItem>
          ))}
        </List>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Le informamos que “Finbra.com” no recaba datos personales sensibles para cumplir con las finalidades previstas
          en este aviso de privacidad.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Nos comprometemos a que los datos personales que se recaban serán tratados bajo las más estrictas medidas de
          seguridad que garanticen su confidencialidad.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Finbra.com recaba datos personales para el tratamiento con fines mercadotécnicos, publicitarios o de
          prospección comercial, las cuales no son necesarias para establecer una relación jurídica entre Finbra.com y
          el titular de los datos.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Finbra.com no realiza tratamientos para fines secundarios o accesorios.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Usted o su representante legal debidamente acreditado podrán limitar el uso o divulgación de sus datos
          personales, solicitando a Finbra.com que cese el uso y manejo de su información, asimismo tiene derecho de
          acceder, rectificar y cancelar sus datos personales, así como de oponerse al tratamiento de los mismos o
          revocar el consentimiento que para tal fin nos haya otorgado, a través de los procedimientos que hemos
          implementado. Para conocer dichos procedimientos, los requisitos, los mecanismos de acreditación de la
          identidad del titular o su representante, la información o documentación que deberá acompañar a la solicitud,
          los plazos, los medios de respuesta, los medios en que se podrá reproducir la información solicitada y, en su
          caso, formularios, sistemas u otros métodos simplificados y habilitados por el responsable para facilitar a
          los titulares el ejercicio de dichos derechos se puede poner en contacto con nuestro Oficial de protección de
          datos personales: José Sesin Canavati en el domicilio ubicado en Avenida Paseo de la Reforma 2654, oficina
          1404-A, Lomas Altas, Miguel Hidalgo, C.P. 11950, Ciudad de México, México o al correo de admin@finbra.com o
          pedir informes al personal de esta sucursal. El ejercicio de cualquiera de dichos derechos no es requisito
          previo ni impide el ejercicio de otro.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Usted puede acudir al Registro Público de Usuarios, en adelante REUS, de la Comisión Nacional para la
          Protección y Defensa de los Usuarios de Servicios Financieros, en adelante CONDUSEF, para limitar el uso y
          divulgación de sus datos personales, o acudir a la CONDUSEF donde puede obtener mayor información.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Asimismo, le informamos que sus datos personales pueden ser transferidos a terceros y ser tratados dentro del
          país, por personas distintas a esta empresa, que le provean de servicios necesarios para su debida operación
          para las finalidades establecidas en el presente Aviso de Privacidad, así como para poder cumplir con las
          obligaciones legales frente al titular de los datos personales y frente a las autoridades de los lugares en
          los que opera. En ese sentido, su información puede ser compartida con el proveedor del servicio de consulta
          de Buró de Crédito, Aseguradoras, Registro Único de Garantías y Fondeadoras de Recursos con el fin de tramitar
          y cumplir con todos los requisitos y así poder otorgarle el servicio y producto que nos solicita. En dichos
          supuestos, se informa que Finbra.com compartirá con las personas que tengan acceso a sus datos personales este
          Aviso de Privacidad a fin de que cumplan con la política de Confidencialidad y de Privacidad de Datos de
          Finbra.com, así como con los principios de protección de datos personales establecidos en la Ley.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Las transferencias de datos personales citadas en este Aviso de Privacidad no requieren de su consentimiento.
          En consecuencia, cualquier otra finalidad no mencionada anteriormente requerirá de su consentimiento expreso.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Si usted no manifiesta su oposición para que sus datos personales sean transferidos, se entenderá que ha
          otorgado su consentimiento para ello.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Finbra.com utiliza cookies para facilitar la navegación en el sitio web “www.finbra.com”. Los servicios
          electrónicos brindados por el responsable permiten recopilar, analizar y conservar información técnica
          relacionada con los hábitos de uso de los mismos, a través de cookies que recaban información de forma
          automática en el momento en que usted hace uso de nuestros servicios electrónicos, si usted navega en el sitio
          web de www.finbra.com sin cambiar la configuración, se considerará que acepta su instalación y uso conforme a
          nuestra política de cookies. Sin embargo, si lo desea, puede cambiar la configuración de cookies en cualquier
          momento; para obtener información más detallada acerca de las cookies y de los medios disponibles para
          deshabilitar su instalación, recomendamos visitar la página web de su navegador preferido.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Para los datos personales que usted proporcione a Finbra.com a través de medios electrónicos como: el sitio
          web, mail, redes sociales, mensajes de WhatsApp; el titular de los datos personales entiende, acepta y
          reconoce que es posible que los sistemas de Finbra.com recopilen datos como tipo de navegador, sistema
          operativo, páginas de internet visitadas, dirección de IP, etc., a través de “cookies” o “web beacons”.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Las finalidades del tratamiento de los datos obtenidos a través de estas tecnologías son las mismas que se
          indican en este Aviso de Privacidad.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          No serán transferidos los datos personales que se obtienen a través de estas tecnologías.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Finbra.com responderá a través hola@finbra.com a todas las solicitudes, dudas, aclaraciones, comentarios y
          quejas que se reciban por los medios electrónicos descritos y bajo ningún motivo se le solicitará el envío de
          datos patrimoniales, económicos o sensibles a través de este medio, salvo mandato judicial de autoridad
          competente. La configuración de su equipo puede aceptar cookies automáticamente, pero si lo prefiere, para
          deshabilitar estas herramientas informáticas puede modificar la configuración de su equipo para rechazar las
          cookies. No será posible que Finbra.com almacene sus preferencias en el sitio web.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Cualquier modificación a este aviso de privacidad podrá consultarla en los letreros colocados en las Oficinas
          de nuestras sucursales o en nuestra página de Internet finbra.com.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_text}
          mt={4}
        >
          Fecha última actualización. 11/11/2024
          <br /><br />
        </Typography>
      </Box>
    </>
  );
};
